import axios from 'axios';
import { serverURL } from '../constants';

export const POLICY_FIELDS = [
  { sessionKey: 'TermsPolicy', apiField: 'terms' },
  { sessionKey: 'PrivacyPolicy', apiField: 'privacy' },
  { sessionKey: 'CookiePolicy', apiField: 'cookies' },
  { sessionKey: 'GdprPolicy', apiField: 'gdpr' },
  { sessionKey: 'LegalPolicy', apiField: 'legal' },
  { sessionKey: 'RefundPolicy', apiField: 'refund' },
  { sessionKey: 'BillingPolicy', apiField: 'billing' },
  { sessionKey: 'CancelPolicy', apiField: 'cancel' },
];

function hostParam() {
  if (typeof window === 'undefined') return '';
  return window.location.host;
}

/**
 * Prefetch org/platform policies via public tenancy API (host-aware).
 */
export async function preloadPolicies() {
  const needsFetch = POLICY_FIELDS.some(({ sessionKey }) => !sessionStorage.getItem(sessionKey));
  if (!needsFetch) return;

  const host = hostParam();
  try {
    await Promise.all(POLICY_FIELDS.map(async ({ sessionKey, apiField }) => {
      if (sessionStorage.getItem(sessionKey)) return;
      try {
        const { data } = await axios.get(`${serverURL}/api/public/policies`, {
          params: { host, type: apiField },
          timeout: 8000,
        });
        if (data?.success && data.content) {
          sessionStorage.setItem(sessionKey, data.content);
        }
      } catch {
        /* per-type best effort */
      }
    }));
  } catch {
    // non-blocking
  }
}

/** Fetch a single policy type (org override → platform default). */
export async function fetchPolicy(type) {
  const { data } = await axios.get(`${serverURL}/api/public/policies`, {
    params: { host: hostParam(), type },
    timeout: 10000,
  });
  return data?.content || '';
}
